import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackCampaignParams } from '../utils/campaignTracking';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
    dmsnowplow?: any;
    snowplow?: any;
    GlobalSnowplowNamespace?: string[];
  }
}

const GA_TRACKING_ID = 'G-80254387'; // Google Analytics 4 ID
const SNOWPLOW_APP_ID = '80254387'; // Snowplow App ID
const SNOWPLOW_COLLECTOR = 'd32hwlnfiv2gyn.cloudfront.net';

const Analytics = () => {
  const location = useLocation();

  // Initialize Snowplow Analytics
  useEffect(() => {
    // Load Snowplow script
    const script = document.createElement('script');
    script.src = '//d32hwlnfiv2gyn.cloudfront.net/sp-2.0.0-dm-0.1.min.js';
    script.async = true;
    
    script.onload = () => {
      if (!window.snowplow) return;
      
      window.dmsnowplow = window.snowplow;
      window.dmsnowplow('newTracker', 'cf', SNOWPLOW_COLLECTOR, {
        appId: SNOWPLOW_APP_ID
      });

      // Track initial page view
      window.dmsnowplow('trackPageView');
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Initialize Google Analytics
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.gtag = window.gtag || function(...args) {
      (window.dataLayer = window.dataLayer || []).push(args);
    };

    window.gtag('js', new Date());
    window.gtag('config', GA_TRACKING_ID, {
      send_page_view: false // We'll send page_view manually to better control timing
    });

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Track page views, campaign parameters, and performance
  useEffect(() => {
    // Track campaign parameters on every navigation
    trackCampaignParams();

    // Google Analytics page view
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href
      });

      // Track performance metrics after page load
      if (window.performance) {
        const metrics = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        window.gtag('event', 'performance_metrics', {
          dns_time: metrics.domainLookupEnd - metrics.domainLookupStart,
          connect_time: metrics.connectEnd - metrics.connectStart,
          ttfb: metrics.responseStart - metrics.requestStart,
          dom_load_time: metrics.domContentLoadedEventEnd - metrics.startTime,
          load_time: metrics.loadEventEnd - metrics.startTime
        });
      }
    }

    // Snowplow page view
    if (window.dmsnowplow) {
      window.dmsnowplow('trackPageView');
    }
  }, [location]);

  return null;
};

export default Analytics;
